import React, { Component } from 'react';

const getHeaderStyle = () => ({
	background: null,
	height: null,
 });

const getContentStyle = () => ({
	background: null,
	height: null,
 });

export default class MenuTabs extends Component {
		
	state = {
		key: 0
	}

	_renderContent = () => {
		const { key } = this.state
		const { children } = this.props

		return (
			<div className={`menu-tabs-content scrollbar`} style={getContentStyle(key)}>
				{children[key]}
			</div>
		)
	}

	render() {
		const { key } = this.state
		const { children } = this.props
		return (
            <div className='main-menu-tabs'>
				<div className='menu-tabs-header'>
					{children.map((item, k)=> {
						const { title, personList } = item.props
						return (
							<div key={`menu-tabs-key-${k}`} 
								 style={getHeaderStyle()}
								 className={`menu-tabs-header-btn ${k===key?'menu-tabs-header-btn-selected':''}`}
								 onClick={()=>this.navIntoTabs(k)}
							>
								{<div>{`${title} (${personList && (personList.length > 0) ? personList.length : 0})`}</div>}
							</div>
						)
					})}
				</div>
				{this._renderContent()}
            </div>
        );
	}

	navIntoTabs = (data) => {
		this.setState({key: data})
	}
}
